import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { DailyReportResponseV4Schema } from "../response/DailyReportResponseV4";

const API_VERSION = 'v4';

interface FilterProps {
    property_id: string;
    start_date: string;
    end_date: string;
    base_on: string;
}

interface DailyReportV4Props {
    filter?: FilterProps;
    orderBy?: string;
    sort?: 'asc' | 'desc';
    type: string | null;
}

const useDailyReportV4 = (params: DailyReportV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-daily',
            API_VERSION,
            params.type,
            JSON.stringify(params.filter),
            params.orderBy,
            params.sort,
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.post(`/${API_VERSION}/channel-manager/group-report-daily`, {
                    filter: params.filter,
                    orderBy: params.orderBy,
                    sort: params.sort,
                });

                const validationResult = DailyReportResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Daily report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Daily report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && !!params.filter.base_on && params.type === "daily_report",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useDailyReportV4;